import React from 'react';

import {FIND_ALL_ANAMNESE_MODELO as query} from '../../../graphql/queries';
import {SelectBase} from './select-apollo';

const getVariables = ({pageNumber, search = '', pageSize = 20}) => {
  return {
    pageableDTO: {pageNumber, pageSize, sortField: 'nome', sortDir: 'ASC'},
    searchDTO: {search, ativo: true},
  };
};

export const SelectAnamneseModelo = (props) => {
  return (
    <SelectBase
      responseObjectName="modelos"
      labelProp="nome"
      query={query}
      getVariables={getVariables}
      {...props}
    />
  );
};
